import React from 'react';
import { Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { LanguageShortcutName } from '../../Models/Models';
import { Utils } from '../../Services/Utils';

const getFlagSrc = (langShort: LanguageShortcutName) =>
    `/images/flags/${langShort.toLocaleLowerCase()}.webp`;

// Flag source assets share a height but vary in width (e.g. sk/cz are 3:2, en/hu are 2:1),
// so images are contained within a fixed box rather than stretched to one shared ratio.
export const FlagImage: React.FC<{ short: LanguageShortcutName; size?: 'sm' | 'md' }> = ({ short, size = 'md' }) => (
    <span className={`st-flag st-flag--${size}`}>
        <img src={getFlagSrc(short)} alt={Utils.capitalizeFirstLetter(short)} className="st-flag__img" />
    </span>
);

export const AddLanguageTile: React.FC<{ accentColor: string; onClick: () => void }> = ({ accentColor, onClick }) => (
    <button
        type="button"
        onClick={onClick}
        className="st-lang-add"
        style={{ '--lang-accent': accentColor } as React.CSSProperties}
    >
        <FontAwesomeIcon icon={faPlus} />
        Pridať jazyk
    </button>
);

export interface LanguagePickerModalProps {
    show: boolean;
    title: string;
    accentColor: string;
    options: readonly LanguageShortcutName[];
    onHide: () => void;
    onPick: (short: LanguageShortcutName) => void;
}

export const LanguagePickerModal: React.FC<LanguagePickerModalProps> = ({ show, title, accentColor, options, onHide, onPick }) => (
    <Modal
        show={show}
        onHide={onHide}
        centered
        className="st-lang-modal"
        style={{ '--lang-accent': accentColor } as React.CSSProperties}
    >
        <div className="st-lang-modal__bar" />
        <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {options.length === 0 ? (
                <p className="st-lang-modal__empty">
                    Žiadne ďalšie jazyky nie sú k dispozícii.
                </p>
            ) : (
                <div className="st-lang-grid">
                    {options.map(short => (
                        <LanguageTile key={short} short={short} accentColor={accentColor} onClick={() => onPick(short)} />
                    ))}
                </div>
            )}
        </Modal.Body>
    </Modal>
);

export const LanguageTile: React.FC<{
    short: LanguageShortcutName;
    accentColor: string;
    onClick: () => void;
}> = ({ short, accentColor, onClick }) => (
    <button
        type="button"
        onClick={onClick}
        className="st-lang-tile"
        style={{ '--lang-accent': accentColor } as React.CSSProperties}
    >
        <FlagImage short={short} size="md" />
        <span className="st-lang-tile__label">{short}</span>
    </button>
);
